import { render, staticRenderFns } from "./CustomersAccessPage.component.pug?vue&type=template&id=561e1371&scoped=true&lang=pug&"
import script from "./CustomersAccessPage.component.ts?vue&type=script&lang=ts&"
export * from "./CustomersAccessPage.component.ts?vue&type=script&lang=ts&"
import style0 from "./CustomersAccessPage.component.scss?vue&type=style&index=0&id=561e1371&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561e1371",
  null
  
)

export default component.exports